import { Field, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import { useGetAllAreasList } from "../Areas/api/getAllAreasList";
import { useGetAllCitiesList } from "../Cities/api/getAllCitiesList";


const PlaceForm = ({ type, initialValues, onSubmit }: PlaceFormProps) => {
    const { t } = useTranslation();

    const getAllAreasQuery = useGetAllAreasList();
    const getAllCitiesQuery = useGetAllCitiesList();

    const validationSchema= Yup.object({
      name: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
      address: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
      address_num: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
      zip: Yup.number().required('Το πεδίο είναι υποχρεωτικό'),
      city_id:Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
      area_id: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
      description:Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    })

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          if (type === "create") {
            onSubmit(values, formikHelpers);
          } else {
            onSubmit(
              values, formikHelpers
            );
          }
        }}
        validationSchema={validationSchema}
      >
        {({ errors, touched, isSubmitting, values, getFieldProps }) => (
          <Form>
            <Container fluid className="p-0">
              <Row>
                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Όνομα Τοποθεσίας")}*`}
                  </label>
                  <Field
                    name="name"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="name"
                   
                  />
                  <div className="text-danger">
                    {errors.name && touched.name && (
                      <div>{errors.name}</div>
                    )}
                  </div>
                </Col>
                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Διεύθυνση")}*`}
                  </label>
                  <Field
                    name="address"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="address"
                   
                  />
                  <div className="text-danger">
                    {errors.address && touched.address && (
                      <div>{errors.address}</div>
                    )}
                  </div>
                </Col>
                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Αριθμός")}*`}
                  </label>
                  <Field
                    name="address_num"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="address_num"
                   
                  />
                  <div className="text-danger">
                    {errors.address_num && touched.address_num && (
                      <div>{errors.address_num}</div>
                    )}
                  </div>
                </Col>
                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Τ.Κ.")}*`}
                  </label>
                  <Field
                    name="zip"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="zip"
                   
                  />
                  <div className="text-danger">
                    {errors.zip && touched.zip && (
                      <div>{errors.zip}</div>
                    )}
                  </div>
                </Col>
                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Πόλη")}*`}
                  </label>
                  <Field
                    as="select"
                    name="city_id"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="city_id"
                  >
                  <option value="">{t("Επιλέξτε Πόλη")}</option>
                  {getAllCitiesQuery.data &&
                    getAllCitiesQuery.data.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.description}
                      </option>
                    ))}
                </Field>
                  <div className="text-danger">
                    {errors.city_id && touched.city_id && (
                      <div>{errors.city_id}</div>
                    )}
                  </div>
                </Col>
                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Περιοχή")}*`}
                  </label>
                  <Field
                  as="select"
                  name="area_id"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="area_id"
                >
                  <option value="">{t("Επιλέξτε Περιοχή")}</option>
                  {getAllAreasQuery.data &&
                    getAllAreasQuery.data.map((area) => (
                      <option key={area.id} value={area.id}>
                        {area.description}
                      </option>
                    ))}
                </Field>
                  <div className="text-danger">
                    {errors.area_id && touched.area_id && (
                      <div>{errors.area_id}</div>
                    )}
                  </div>
                </Col>
                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Εμπορική")}*`}
                  </label>
                  <Field
                    type="checkbox"
                    name="is_emporiki"
                    field="is_emporiki"
                  />
                  <div className="text-danger">
                    {errors.is_emporiki && touched.is_emporiki && (
                      <div>{errors.is_emporiki}</div>
                    )}
                  </div>
                </Col>
                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Citibank")}*`}
                  </label>
                  <Field
                    type="checkbox"
                    name="is_citi"
                    field="is_citi"
                  />
                  <div className="text-danger">
                    {errors.is_citi && touched.is_citi && (
                      <div>{errors.is_citi}</div>
                    )}
                  </div>
                </Col>
                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Περιγραφή")}*`}
                  </label>
                  <Field
                    name="description"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="description"
                    as ="textarea"
                  />
                  <div className="text-danger">
                    {errors.description && touched.description && (
                      <div>{errors.description}</div>
                    )}
                  </div>
                </Col>
              </Row>
            </Container>

            <div className="mb-3">
              <Button
                type="submit"
                size="sm"
                styletype="primary"
                disabled={isSubmitting}
              >
                {type == "create" ? t("Δημιουργία") : t("Αποθήκευση")}
              </Button>
            </div>
          </Form>
      )}
      </Formik>
  )
}

export default PlaceForm;

type CreateOrEdit =
  | {
      type: "create";
      initialValues: ICreatePlaceForm;
      onSubmit: (
        values: ICreatePlaceForm,
        formikHelpers: FormikHelpers<ICreatePlaceForm>
      ) => void;
    }
  | {
      type: "edit";
      initialValues: IEditPlaceForm;
      onSubmit: (
        values: IEditPlaceForm,
        formikHelpers: FormikHelpers<IEditPlaceForm>
      ) => void;
    };

type PlaceFormProps = CreateOrEdit;